import { Card, Table, Drawer } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { EditOutlined, PlusOutlined } from "@ant-design/icons"; // Use react-icons for consistency
import { useDispatch, useSelector } from "react-redux";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import CreateGameForm from "./CreateGameForm";
import { AiFillDelete } from "react-icons/ai";
import CrmSearch from "../CRM/CommonUi/CrmSearch";
import ConfirmModal from "../ConfirmationModal/ConfirmModal";
import downloadLogo from "../../assets/images/download-logo.svg";
import { deleteGame, getAllGames } from "../../redux/rtk/features/game/gameSlice";

const TableComponent = () => {
  const dispatch = useDispatch();
  const { list: gameList, isDeleting, isFetchingAll } = useSelector((state) => state.game);
  const [open, setOpen] = useState(false); // Single drawer state
  const [editData, setEditData] = useState(null); // Track the row being edited
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [gameToDelete, setGameToDelete] = useState(null);
  const [filteredList, setFilteredList] = useState(gameList);

  useEffect(() => {
    setFilteredList(gameList)
  }, [gameList])

  useEffect(() => {
    dispatch(getAllGames());
  }, [dispatch]);

  const deleteHandler = async (id) => {
    try {
      await dispatch(deleteGame(id)).unwrap();
      dispatch(getAllGames());
    } catch (error) {
      console.error(error);
    }
  };

  const handleOk = async () => {
    try {
      await deleteHandler(gameToDelete);
      setIsModalOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setGameToDelete(null);
  };

  const openEditDrawer = (id, values) => {
    setEditData({ id, values });
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setEditData(null);
  };

  const columns = [
    { title: "No", dataIndex: "id" },
    { title: "Game Room Name", dataIndex: "gameName" },
    { title: "Difficulty Level", dataIndex: "gameDificultyLevel" },
    { title: "Play Time(Min)", dataIndex: "gamePlayTime" },
    { title: "Success Rate(%)", dataIndex: "gameSuccessRate", render: (gameSuccessRate) => gameSuccessRate || '-' },
    {
      title: "Action",
      dataIndex: "id",
      render: (id, values) => (
        <span className="flex items-center gap-2">
          <button
            onClick={() => openEditDrawer(id, values)}
            className="text-black text-lg p-1 rounded cursor-pointer flex items-center gap-2"
          >
            <EditOutlined />
          </button>
          <span
            onClick={() => {
              setIsModalOpen(true);
              setGameToDelete(id);
            }}
            className='text-[#EF4444] text-xl font-bold rounded mr-2 cursor-pointer inline-flex items-center justify-center'
          >
            <AiFillDelete />
          </span>
        </span>
      ),
    },
  ];

  const [columnsToShow, setColumnsToShow] = useState([]);
  useEffect(() => {
    setColumnsToShow(columns);
  }, []);
  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  // Basic Search 
  function handleSearch(value) {
    if (value === "") {
      setFilteredList(gameList)
    } else {
      const filteredGames = gameList.filter((game) => {
        return game.gameName.toLowerCase().includes(value.toLowerCase())
      })
      setFilteredList(filteredGames)
    }
  }
  return (
    <Card className="mb-[16px] game-card border-none border-radius-bottom">
      <div className="flex flex-col sm:flex-row lg:items-center justify-between gap-2 mb-4 w-full ">
        <div className="flex items-center gap-2">
          <span className="border px-2 py-1 rounded cursor-pointer btn-secondary text-white">
            <CSVLink
              data={filteredList.map(({ userProduct, ...rest }) => rest)}
              className="flex items-center gap-2 btn btn-dark btn-sm bg-transparent text-[#E5383B] text-[10px] md:text-[14px]"
              filename="Games-List"
            >
              <img src={downloadLogo} />
              Download CSV
            </CSVLink>
          </span>
          <ColVisibilityDropdown
            options={columns}
            columns={columns}
            columnsToShowHandler={columnsToShowHandler}
          />
        </div>
        <div>
          <CrmSearch handleSearch={handleSearch} />
        </div>
      </div>
      <Table
        loading={isFetchingAll}
        columns={columnsToShow}
        dataSource={filteredList?.map((item) => ({ ...item, key: item.id }))}
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true, // Allow changing page size
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        scroll={{ x: 500 }}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "even-row" : "odd-row"
        }
      />
      <Drawer
        width={window.innerWidth <= 768 ? "100%" : "40%"}
        title="Update Game"
        placement="right"
        onClose={onClose}
        open={open}
        destroyOnClose={true}
      >
        {editData && (
          <CreateGameForm edit={editData} onClose={onClose} />
        )}
      </Drawer>
      <ConfirmModal
        title="Delete Game"
        loading={isDeleting}
        message="Are you sure you want to delete this game?"
        open={isModalOpen}
        handleCloseModal={() => setIsModalOpen(false)}
        handleOk={handleOk}
        handleCancel={handleCancel}
        okText="Delete"
        cancelText="Cancel"
      />
    </Card>
  );
};

export default TableComponent;